import { _, _any } from "i18n";
import { PlayerRatingModalData } from "../../../../gamePage/types";
import { SliderField } from "../../../../../../ui-kit-v2/src/slider/slider";
import { formatPlayerRatingScore, roundPlayerRatingScore } from "../../../format-player-rating-score";

interface PlayerRatingTabProps {
	modalState: PlayerRatingModalData;
	setModalState: React.Dispatch<React.SetStateAction<PlayerRatingModalData>>;
}

export function PlayerRatingTab({ modalState, setModalState }: PlayerRatingTabProps) {
	return (
		<div>
			<div className="playerRatingModal-ratingHeader">
				<span className="rating-title">{_any("gamePage.playerRating.modal.rating.title", { player: modalState.name ?? "" })}</span>
				<span className="rating-text">{_("gamePage.playerRating.modal.rating.text")}</span>
			</div>
			<div className="playerRatingModal-slider">
				<SliderField
					onChange={(value) =>
						setModalState({
							...modalState,
							rating: { ...modalState.rating, score: roundPlayerRatingScore(value) },
						})
					}
					value={modalState.rating?.score ?? 0}
					minValue={0}
					maxValue={10}
					step={0.1}
					formatOutput={formatPlayerRatingScore}
				/>
			</div>
		</div>
	);
}
